<template>
  <van-row type="flex" class="continer" justify="space-between">

    <van-col span="4" v-if="!showBack">
    </van-col>
    <van-col span="4" class="menu-box" v-else>
      <van-icon class="arrow-left" name="arrow-left" @click="goback" />
    </van-col>

    <van-col span="16" class="page-name">{{headName}}</van-col>

    <van-col span="4"></van-col>
  </van-row>
</template>

<script>
export default {
  name: "businessHeader",
  data() {
    return {
      headName: "",
      showBack: false,
      navRightBtVisible: true,
      RightNavBtName: "plus",
      navRightTitleBtVisible: false,
      navRightEditBtVisible: false,
      lasterRouterPath: "",
    };
  },
  created() {},
  watch: {
    //监听路由变化
    $route: {
      handler(to) {
        this.headName = to.name;
        if (to.meta.type != 1) {
          this.showBack = true;
        } else {
          this.showBack = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    showSidbar() {
      this.$store.commit("SET_SHOWSIDBAR", true);
    },
    goback() {
      // if (this.$route.path == "/type/detail") {
      //   this.$store.commit("SET_DETAIL_GOBACK", true);
      //   this.$router.push("/index");
      //   return;
      // } else if (this.$route.path == "/type/result") {
      //   this.$router.push({
      //     path: "/myorders/0",
      //   });
      //   return;
      // } else {
      //   console.log("??????11222");
      //   this.$store.commit("SET_DETAIL_GOBACK", false);
      //   this.$router.go(-1);

      if (this.$route.path == "/selectAddress") {
        //   console.log("?????");
        this.$router.replace({
          path: "/order",
          query: { cartId: sessionStorage.getItem("cartId") },
        });
        return;
      }

      this.$router.go(-1);

      //  else if (this.$route.path == "/selectAddress") {
      //   this.$router.push({
      //     path: "/order",
      //     query: { cartId: sessionStorage.getItem("cartId") },
      //   });
      //   return;
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.CSSRightNavTitleBt {
  font-family: PingFangSC-Medium;
  font-size: 1.8rem;
  color: #8f9bb3;
  text-align: right;
  line-height: 1.8rem;
}
.continer {
  height: 60px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  z-index: 1;
  position: fixed;
  top: 0;

  .page-name {
    font-family: PingFangSC-Regular;
    font-size: 1.8rem;
    color: #000;
    letter-spacing: 0;
    text-align: center;
  }
}
.menu-box {
  background-color: transparent;
  height: 100%;
  line-height: 7.5rem;
  .arrow-left {
    font-size: 2.3rem;
    margin-left: -1rem;
  }
}
.go-back {
  color: #000;
  font-size: 2.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/businessHeader.vue